/// <amd-module name="VSS/Redux/Modules/Navigation/NavigationActions" />
import { createAction, ActionsUnion } from "redux/Utils/ActionHelper";

export const enum NavigationActionTypes {
    FPSNavigateToUrl = "Navigation/FPSNavigateToUrl"
};

export const NavigationActions = {
    fpsNavigateToUrl: (url: string, recordHistoryEntry: boolean = true) => createAction(NavigationActionTypes.FPSNavigateToUrl, { url, recordHistoryEntry })
}

export type NavigationActions = ActionsUnion<typeof NavigationActions>;
